module.exports = __webpack_public_path__ + "static/media/prison_break.069a0a13.webp";